import React, { useState } from 'react';
import {
  MobileProductsContainer,
  ProductFilter,
  ProductListContainer
} from '../../styles';
import { Autocomplete } from '@material-ui/lab';
import Environment from 'utils/environments';
import ProductCard from './components/ProductCard';
import {
  TextField,
  Typography,
  useMediaQuery
} from '@material-ui/core';
import getOptions from 'services/getOptions';
import SkeletonProductCard from './components/SkeletonProductCard';

const environments = Environment(process.env.REACT_APP_ENV);

function MobileProductCards({
  mainLoading,
  products,
  getId,
  setModalSettings,
  modalSettings,
  handleFilter,
  labelManagerHasAllPermissions,
  isLabelUser
}) {
  const isPhoneScreen = useMediaQuery('(max-width: 576px)');
  const [productOptions, setProductOptions] = useState([]);
  const [productDescription, setProductDescription] = useState();
  const [filterSelectedProduct, setFilterSelectedProduct] = useState();
  const [debounceTimeList, setDebounceTimeList] = useState([]);

  const handleClearProductFilter = () => {
    setProductDescription(null);
    setFilterSelectedProduct(null);
    getProductsOptions(null);
  };

  const getProductsOptions = (value) => {
    debounceTimeList.forEach((el) => clearTimeout(el));

    const newTimer = setTimeout(() => {
      getOptions(
        `${environments.catalog}/products`,
        'productOptions',
        productOptions,
        setProductOptions,
        getId,
        {
          autoComplete: true,
          ...(value && { productDescription: value })
        },
        null,
        10
      );
    }, 1500);

    setDebounceTimeList([...debounceTimeList, newTimer]);
  };

  return (
    <MobileProductsContainer>
      <div className="fakeWhiteBg" />

      <ProductFilter>
        <Autocomplete
          freeSolo
          // onChange={(_, value) => {
          //   if (typeof value === 'string') {
          //     setFilterSelectedProduct(null);
          //     setProductDescription(value);
          //     handleFilter('productDescription', value);
          //   } else {
          //     setFilterSelectedProduct(value);
          //     setProductDescription(value?.description || '');
          //     handleFilter('productId', value?.id || null);
          //   }
          // }}
          className="autocompleteSmall productFilterAutocomplete"
          fullWidth
          size="small"
          variant="outlined"
          getOptionLabel={(option) =>
            typeof option === 'string' ? option : option?.description
          }
          // options={productOptions}
          options={[]}
          value={filterSelectedProduct || null}
          inputValue={productDescription || ''}
          // onFocus={() => {
          //   if (!productOptions.length) getProductsOptions();
          // }}
          onInputChange={(_, value, reason) => {
            if (reason === 'input') {
              setProductDescription(value);

              debounceTimeList.forEach((el) => clearTimeout(el));

              const newTimer = setTimeout(() => {
                handleFilter('productDescription', value);
              }, 600);

              setDebounceTimeList([...debounceTimeList, newTimer]);
            }

            if (reason === 'clear') {
              handleClearProductFilter();
              handleFilter('productDescription', null);
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              id={params.id}
              name="product"
              placeholder={
                isPhoneScreen
                  ? 'Localize o produto para imprimir...'
                  : 'Localize o produto e clique no card para imprimir a etiqueta...'
              }
              // onKeyDown={(event) => {
              //   if (event.key === 'Enter' && productDescription) {
              //     handleFilter('productDescription', productDescription);
              //   }

              //   if (
              //     event.key === 'Backspace' &&
              //     (!productDescription || productDescription.length <= 1)
              //   ) {
              //     handleClearProductFilter();
              //     handleFilter('productDescription', null);
              //   }
              // }}
            />
          )}
          renderOption={(option) => (
            <Typography style={{ fontSize: '12px', fontFamily: 'Lato' }}>
              {option?.description}
            </Typography>
          )}
        />
      </ProductFilter>

      <ProductListContainer>
        {mainLoading ? (
          [...Array(3)].map((_, i) => <SkeletonProductCard key={i} />)
        ) : products?.length ? (
          products.map((product) => (
            <ProductCard
              key={product.id}
              product={product}
              setModalSettings={setModalSettings}
              modalSettings={modalSettings}
              labelManagerHasAllPermissions={labelManagerHasAllPermissions}
              isLabelUser={isLabelUser}
            />
          ))
        ) : (
          <span className="emptyLine bold w100">Não há nenhum produto.</span>
        )}
      </ProductListContainer>
    </MobileProductsContainer>
  );
}

export default MobileProductCards;
